import { UiSource } from '@weave/schema-gen-ts/dist/shared/wsearch/v1/ui_source.pb';
import { SearchHistory } from '@frontend/search-history';
import { GlobalSearchMain } from './global-search-main';
import { GlobalSearchSection, GlobalSearchContent, GlobalSearchFilters } from './molecules';
import { GlobalSearchEmptyState } from './molecules/global-search-empty-state';
import { GlobalSearchProvider } from './provider';

type GlobalSearchProps = {
  children: React.ReactNode;
  className?: string;
};

export const GlobalSearch = ({ children, className }: GlobalSearchProps) => {
  return (
    <GlobalSearchProvider>
      <GlobalSearchMain className={className}>{children}</GlobalSearchMain>
      <SearchHistory id={UiSource.GLOBAL_SEARCH} />
    </GlobalSearchProvider>
  );
};

GlobalSearch.Filters = GlobalSearchFilters;
GlobalSearch.Content = GlobalSearchContent;
GlobalSearch.Section = GlobalSearchSection;
GlobalSearch.EmptyState = GlobalSearchEmptyState;
